import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remote',
  templateUrl: './remote.component.html',
  styleUrls: ['./remote.component.scss']
})
export class RemoteComponent implements OnInit {
 
  DUMMY_REMOTE_CLIENTS: RemoteClient[] = [
  {
    id: '1',
    name: 'Fresh FM Shoutcast PC',
    group: 'FreshFM',
    rustdeskId: '485554566',
    pin: 'Carlyiscute9!',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '2',
    name: 'FreshFM Studio Main Desk',
    group: 'FreshFM',
    rustdeskId: '318611928',
    pin: 'Freshfm@3550',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '3',
    name: 'FreshFM Studio Secondary Desk',
    group: 'FreshFM',
    rustdeskId: '29514068',
    pin: 'Freshfm@3550',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '4',
    name: 'SummersPC',
    group: 'Repairlab',
    rustdeskId: '1310048707',
    pin: 'Carlyiscute9!',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '5',
    name: 'Microscope PC',
    group: 'Repairlab',
    rustdeskId: '300974579',
    pin: 'Carlyiscute9!',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '6',
    name: 'Arya PC',
    group: 'Repairlab',
    rustdeskId: '295627199',
    pin: 'Carlyiscute9!',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '7',
    name: 'Bed PC',
    group: 'Repairlab',
    rustdeskId: '262925414',
    pin: 'Carlyiscute9!',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '8',
    name: 'Gary PC',
    group: 'Bendigo Electronics',
    rustdeskId: '198882846',
    pin: 'Sparkysip@3550',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  },
  {
    id: '9',
    name: 'Backroom PC',
    group: 'Bendigo Electronics',
    rustdeskId: '87635095',
    pin: 'Sparkysip@3550',
    contactName: 'Walter White',
    contactPhone: '0402 111 222',
    contactEmail: '',
  }
  ];

  searchTerm = '';
  visibleClients: RemoteClient[] = [];

  constructor() { }

  ngOnInit(): void {
    this.applySearch();
  }

  onAddClient() {}

  connect(client: RemoteClient): void {
    if (!client || !client.rustdeskId) {
      console.error('No RustDesk ID for client', client);
      return;
    }

    const id = client.rustdeskId.trim();
    const pin = client.pin?.trim();

    // rustdesk://<id>?password=<pin>
    let url = `rustdesk://${encodeURIComponent(id)}`;
    if (pin && pin.length > 0) {
      url += `?password=${encodeURIComponent(pin)}`;
    }

    console.log('Connecting to RustDesk client:', {
      name: client.name,
      id,
      url,
    });

    // Use _self so it just hands off to the protocol handler
    window.open(url, '_self');
    // or:
    // window.location.href = url;
  }

  copyId(id: string) {}

  applySearch(): void {
    const term = this.searchTerm?.trim().toLowerCase();

    if (!term) {
      this.visibleClients = this.DUMMY_REMOTE_CLIENTS;
      return;
    }

    this.visibleClients = this.DUMMY_REMOTE_CLIENTS.filter((client) => {
      const fields = [
        client.name,
        client.rustdeskId,
        client.pin,
        client.group,
        client.contactName,
        client.contactPhone,
        client.contactEmail,
      ]
        .filter(Boolean)
        .map((value) => value!.toString().toLowerCase());

      return fields.some((value) => value.includes(term));
    });
  }

  get groupedClients(): { name: string; clients: RemoteClient[] }[] {
    const map = new Map<string, RemoteClient[]>();

    for (const client of this.visibleClients) {
      const key = client.group?.trim() || 'Ungrouped';
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)!.push(client);
    }

    return Array.from(map.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([name, clients]) => ({
        name,
        clients: clients.sort((c1, c2) =>
          c1.name.localeCompare(c2.name)
        ),
      }));
  }
}


interface RemoteClient {
  id: string;                     // internal Autopilot ID (UUID or ObjectId)
  
  name: string;                   // Display name: "Emma's Office PC"
  group?: string;                 // Optional category: "Shops", "Home", "Servers"

  rustdeskId: string;             // RustDesk ID (9/12 digit string)
  pin?: string;                   // Password / PIN for unattended access

  contactName?: string;           // Owner or onsite contact
  contactPhone?: string;
  contactEmail?: string;
}
